if (!customElements.get('ondelie-water')) {
  class OndelieWater extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-ow-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-ow-panel]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
      });

      this.mountReveal();
    }

    select(index, moveFocus = false) {
      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;

        if (isActive && moveFocus) tab.focus();
      });

      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === index;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
      });
    }

    handleKeydown(event, index) {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;

      event.preventDefault();
      let nextIndex = index;

      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      }
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (index + 1) % this.tabs.length;
      }

      this.select(nextIndex, true);
    }

    mountReveal() {
      this.classList.add('is-mounted');

      if (!('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }

      this.revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

      this.revealObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.revealObserver) this.revealObserver.disconnect();
    }
  }

  customElements.define('ondelie-water', OndelieWater);
}
